// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".map-link[data-v-0f8c3fa0]{margin-bottom:.75rem;margin-left:-.25rem;width:calc(100% + .5rem);height:136px;max-width:600px}.jd-section__multi[data-v-0f8c3fa0]{display:flex;flex-direction:row;width:100%;align-items:center}.jd-section__multi--item[data-v-0f8c3fa0]{flex:1 1;margin-right:3.25rem;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.jd-section__multi--more[data-v-0f8c3fa0]{flex-shrink:0}@media (min-width:960px){.map-link[data-v-0f8c3fa0]{margin-bottom:1rem}}", ""]);
// Exports
module.exports = exports;
